import React, { Dispatch, useMemo } from 'react';

import Location from '@r6digital/rapidstor-types/react/entities/Location';
import UnitType from '@r6digital/rapidstor-types/react/entities/UnitType';
import Deal from '@r6digital/rapidstor-types/types/Deal';

import { formatCurrency } from '@/utils/currency';

// import { stringifyNumber } from '@/features/rapidstor/helpers';
import classes from './styles.module.scss';
// import { formatSize } from '@/features/rapidstor/helpers';

interface Props extends React.HTMLAttributes<HTMLElement> {
    option: UnitType;
    dealObject?: Deal;
    deal?: string;
    initialRate?: number;
    desktopOption?: boolean;
    location: Location;
    selected: boolean;
    default?: boolean;
    showTotalPrice?: boolean;
    wizard?: boolean;
    setDefaultUnitType?: () => void;
    setSelectedID: Dispatch<React.SetStateAction<string>>;
}

export default function MapOption(props: Props) {
    // const formattedFloor = useMemo(() => {
    //     return `${stringifyNumber(props.option.floor)} Floor`;
    // }, [props.option.floor]);

    /**
     * Helper memo for displaying the price difference between the selected unitType and the upsell unitType.
     */
    const priceDifferenceDisplay = useMemo(() => {
        const optionRate = props.option.rates.rate;

        const priceDifference = optionRate - (props.initialRate ?? 0);

        if (props.default) {
            return formatCurrency(optionRate, props.location);
        }

        if (props.showTotalPrice) {
            return formatCurrency(optionRate, props.location);
        }

        if (priceDifference === 0) {
            return `${formatCurrency(optionRate, props.location, false, false)}`;
        }

        if (priceDifference > 0) {
            return `+${formatCurrency(
                priceDifference ?? 0,
                props.location,
                false,
                false
            )}`;
        } else {
            return `-${formatCurrency(
                priceDifference ?? 0,
                props.location,
                false,
                false
            )}`;
        }
    }, [
        props.default,
        props.initialRate,
        props.location,
        props.option.rates.rate,
        props.showTotalPrice,
    ]);

    return (
        <div className={`${classes.map}`}>
            <div className={`${classes.first}`}>
                <div className={`${classes.opt_in}`}>
                    <div className={`${classes.custom_checkbox}`}>
                        <input
                            id={props.option._id}
                            type='checkbox'
                            checked={props.selected ? true : false}
                            onChange={() => {
                                if (props.selected) {
                                    props.setDefaultUnitType?.();
                                } else {
                                    props.setSelectedID(props.option._id);
                                }
                            }}
                        />
                        <label
                            htmlFor={props.option._id}
                            className={`${classes.label}`}
                        ></label>
                    </div>
                    <div className={`${classes.upsell_description}`}>
                        <span className={`${classes.name}`}>{props.option.typeName}</span>
                    </div>
                </div>
            </div>
            <div className={`${classes.last}`}>
                <span className={`${classes.price}`}>{priceDifferenceDisplay}</span>
            </div>
        </div>
    );
}
